import { useState } from 'react'
import { useSelector } from 'react-redux'
import { LabeledText } from 'src/components/UI'
import Modal from 'src/components/UI/CustomUI/molecules/Modal'
import { getEstimate } from 'src/ducks/estimate/selectors'
import { EstimateItem } from 'src/ducks/types'
import { formatTimestamp, getPreferredTimeWindowLabel } from 'src/helpers'
import { useIsLgScreen, useIsXlScreen } from 'src/hooks'
import { ContentBox, Divider, TabBox } from '../../Templates'
import SitevisitsModal from './SiteVisitsModal'

const EstimateInfo = () => {
  const estimate = useSelector(getEstimate())
  const [xlScreen] = useIsXlScreen()
  const [lgScreen] = useIsLgScreen()
  const [modalOpen, setModalOpen] = useState(false)

  const repairTimeLineMapper = {
    PRELISTING: 'Prelisting',
    ASAP: 'ASAP',
    BEFORE_CLOSE: 'Before Close',
    AFTER_CLOSE: 'After Close',
    NEVER: 'Never',
    ONE_WEEK: 'One Week',
    THIRTY_DAYS: 'Thirty Days',
    SIXTY_DAYS: 'Sixty Days',
    OVER_SIXTY_DAYS: 'Over Sixty Days'
  }

  const {
    properties,
    createdOn,
    deliveryService,
    repairTimeline,
  } = estimate || {} as EstimateItem

  const { address, territory, estimateDeliveredOn, preferredStartDate } = properties || {}

  const estimateSent = estimateDeliveredOn ? formatTimestamp(estimateDeliveredOn, 'MM/DD/YYYY') : '-'
  const deliveryRequested = deliveryService?.title || '-'
  const deliveryDays = deliveryService?.days || '-'
  const repairTimelineValue = repairTimeLineMapper[repairTimeline] || '-'
  const preferredStartDateValue = preferredStartDate ? formatTimestamp(preferredStartDate, 'MM/DD/YYYY') : '-'
  const preferredTimeWindowValue = getPreferredTimeWindowLabel(preferredStartDate, address?.timeZone)

  return (
    <TabBox>
      <Modal
        setOpen={setModalOpen}
        open={modalOpen}
        title='Site Visit History'
        showClose
        size='xs'
      >
        <SitevisitsModal />
      </Modal>
      <ContentBox gridTemplateColumns={'1fr'}>
        <LabeledText labelValue='Address:' textValue={estimate?.properties.address?.line1} />
        <ContentBox gridTemplateColumns={xlScreen || lgScreen ? '1fr 1fr' : '1fr'}>
          <LabeledText labelValue='City:' textValue={address?.city} />
          <LabeledText labelValue='State:' textValue={address?.state} />
          <LabeledText labelValue='Territory:' textValue={territory?.title} />
          <LabeledText labelValue='ZIP Code:' textValue={address?.zipCode} />
        </ContentBox>
      </ContentBox>
      <Divider />
      <ContentBox gridTemplateColumns={xlScreen || lgScreen ? '1fr 1fr' : '1fr'}>
        <LabeledText
          labelValue='Created On:'
          textValue={formatTimestamp(createdOn, 'MM/DD/YYYY')}
          flexDirection={'column'}
        />
        <LabeledText
          labelValue='Estimate Sent:'
          textValue={estimateSent}
          flexDirection={'column'}
        />
      </ContentBox>
      <ContentBox gridTemplateColumns={xlScreen || lgScreen ? '1fr 1fr 1fr' : '1fr'}>
        <LabeledText
          labelValue='Delivery Requested:'
          textValue={deliveryRequested}
          flexDirection={'column'}
        />
        <LabeledText
          labelValue='Repairs Requested:'
          textValue={repairTimelineValue}
          flexDirection={'column'}
        />
        <LabeledText
          labelValue='Delivery Days:'
          textValue={`${deliveryDays}`}
          flexDirection={'column'}
        />
        <LabeledText
          labelValue='Preferred Start Date:'
          textValue={preferredStartDateValue}
          flexDirection={'column'}
        />
        <LabeledText
          labelValue='Preferred Time:'
          textValue={preferredTimeWindowValue}
          flexDirection={'column'}
        />
      </ContentBox>
    </TabBox>
  )
}

export default EstimateInfo
